import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Blogposts, Challenges, Projects, Tutorials } from '../';
import styles from './Community.module.sass';

export const Community = () => {
  const schoolTitle = useSelector((state) => state.get('school').get('hero').get('title'));
  const communityContent = useSelector((state) => state.get('community').get('tabCommunity'))?.toJS();
  const [showChallenges, setShowChallenges] = useState(false);
  const [showAnchors, setShowAnchors] = useState(false);

  const intersectionOptions = {
    root: null,
    rootMargin: '-20% 0px -70% 0px',
    threshold: 0,
  };

  const callbackIntersection = (entries) => {
    entries.forEach((entry) => {
      const id = entry.target.id;
      const element = document.querySelector(`[href="#${id}"]`);

      if (entry.intersectionRatio > 0) {
        element && element.classList.add(styles.active);
      } else {
        element && element.classList.remove(styles.active);
      }
    });
  };

  const renderLink = (link, copy) => (
    <li>
      <a href={link}>{copy}</a>
    </li>
  );

  useEffect(() => {
    const observer = new IntersectionObserver(callbackIntersection, intersectionOptions);
    const sections = document.querySelectorAll('#Community section');
    sections.forEach((element) => observer.observe(element));

    if (sections.length > 1) setShowAnchors(true);

    return () => sections.forEach((element) => observer.unobserve(element));
  }, []);

  return (
    <section className={styles.Community} id="Community">
      <div className="u-wrapper">
        <div className={styles.Top}>
          <h5>Comunidad de {schoolTitle}</h5>
          {showAnchors && (
            <nav>
              <ul>
                {communityContent.blogposts.populars.length > 0 && renderLink('#blogposts', 'Blogposts')}
                {showChallenges && renderLink('#challenges', 'Retos')}
                {communityContent.projects.length > 0 && renderLink('#projects', 'Proyectos')}
                {communityContent.tutorials.populars.length > 0 && renderLink('#tutorials', 'Tutoriales')}
              </ul>
            </nav>
          )}
        </div>
        <Blogposts />
        <Challenges setShowChallenges={setShowChallenges} />
        <Projects />
        <Tutorials />
      </div>
    </section>
  );
};
